import { Suspense, useEffect } from 'react'
import type { Route as RouteType } from '@onhandtech/onhand-fe-shared/lib/contracts/config/routes'
import { getRouteByKey } from '@onhandtech/onhand-fe-shared/lib/router'
import Layout from 'components/layout/layout'
import { getConfig } from 'config/configuration'
import type { RouteKey } from 'contracts/config/routes'
import NotFound from 'pages/not-found/not-found'
import { useSelector } from 'react-redux'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { isStaffAccountSelector } from 'redux/authentication/selectors'

import { routeMap } from './route-map'
import { getRoutePath } from './router.utils'

const Router = () => {
  const { routes } = getConfig()

  const userSignedIn = useSelector(isStaffAccountSelector)

  const routesComponents = routeMap
    .map(({ component: Component, key }) => {
      const route = getRouteByKey<RouteKey, RouteType<RouteKey>>(key, routes)
      return route ? <Route key={key} Component={Component} path={route.path} /> : null
    })
    .filter((element): element is JSX.Element => element !== null)

  useEffect(() => {
    if (!userSignedIn && window.location.pathname === '/') {
      window.location.replace(getRoutePath('SIGN_IN'))
    }
  }, [userSignedIn])

  const domRouter = createBrowserRouter(
    createRoutesFromElements(
      <Route
        errorElement={<NotFound />}
        element={<Suspense fallback={null}>{<Layout />}</Suspense>}
      >
        {routesComponents}
      </Route>,
    ),
  )
  return <RouterProvider router={domRouter} />
}

export default Router
